import React from 'react';
import PortalLogin from './PortalLogin';

export const BrokerLoginPage = () => (
  <PortalLogin
    portal="broker"
    title="Broker / Affiliate Sign-In"
    subtitle="Track referrals, see commission status, and grab your trackable referral links."
    redirectTo="/broker/dashboard"
  />
);

export const OwnerLoginPage = () => (
  <PortalLogin
    portal="owner"
    title="Owner Sign-In"
    subtitle="Live bookings on your vehicles, monthly payouts, and 1099-ready statements."
    redirectTo="/owners/dashboard"
  />
);
